import React, { useEffect, useState } from "react";
import {
  CircularProgress,
  Grid,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
} from "@mui/material";
import { SlReload } from "react-icons/sl";
import { IoSearchOutline } from "react-icons/io5";
import {
  CustomTablePagination,
  StyledTableCell,
  StyledTableRow,
} from "../../Components/MaterialTableStyle/StyleTableCell";
import CustomTooltip from "../../Components/Input/CustomToolTip";

import EnshieldLogo from "../../Assets/images/logo.svg";
import { FormatDate } from "../../Components/DateFormats/DateFromat";
import CustomText_input from "../../Components/Input/CustomText_input";
import { REACT_APP_TRANSACTION_HASHLINK } from '../../Config/Config';

const WithDrawHistory = ({ WithdrawData , reloadtransaction }) => {
  const [InitialData, setInitialData] = useState([]);
  const [Loader, setLoader] = useState(true);
  const [SearchQuery, setSearchQuery] = useState("");
  const [RowsPerPage, setRowsPerPage] = useState(10);
  const [Page, setPage] = useState(0);
  const [Page1, setPage1] = useState(1);

  const HandleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
    setPage1(1);
  };

  const HandleChangePage = (event, newPage) => {
    setPage(newPage);
    setPage1(newPage + 1);
  };

  const HandleChangePagePrev = (event, newPage) => {
    setPage(newPage - 1);
    setPage1(newPage);
  };

  useEffect(() => {
    setInitialData(WithdrawData);
    setLoader(true);
  }, [WithdrawData]);

  useEffect(() => {
    if (Loader) {
      setTimeout(() => {
        setLoader(false);
      }, 1000);
    }
  }, [Loader]);

  const HandleSearch = (e) => {
    setSearchQuery(e);
    let searched = [...WithdrawData].filter(
      (a) =>
        a.transactionHash?.toLowerCase().includes(e?.toLowerCase()) ||
        a.amount?.toString().toLowerCase().includes(e?.toLowerCase())
    
    );
    setInitialData(searched);
  };

  return (
    <Grid
      container
      lg={12}
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      justifyContent={"flex-start"}
    >
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item lg={6} xs={12}>
          <h5 className="text-left">OZK Claim History</h5>
        </Grid>
        <Grid
          item
          lg={6}
          xs={12}
          display={"flex"}
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid item sm={8} xs={8}>
            <CustomText_input
              placeholder={"Search..."}
              isBorder={true}
              borderColor={"#fff"}
              Value={SearchQuery}
              HandleInput={(e) => HandleSearch(e)}
              StartIcon={<IoSearchOutline className="text-light" size={25} />}
              height={"40px"}
            />
          </Grid>
          <Grid item>
            <button
              className="btn  rounded mx-3 btn-0 GlassCard"
              onClick={() => {reloadtransaction()}}
            >
              <SlReload color="#FFED8C" size={"22px"} />
            </button>
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        lg={12}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <TableContainer
          className="customeScroll mt-3"
          sx={{ border: "1px solid #FFFFFF1A",borderRadius:"15px", height: "60vh", overflowY: "auto" }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead root>
              <StyledTableRow>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  No
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Transaction Hash
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Claimed Tokens
                </TableCell>
                <TableCell
                  style={{
                    backgroundColor: "#3B3B3D",
                    color: "#FFF",
                    fontSize: "14px",
                    fontFamily: "PoppinsSemiBold",
                  }}
                >
                  Date & Time{" "}
                </TableCell>
              </StyledTableRow>
            </TableHead>
            {!Loader ? (
              InitialData?.length > 0 ? (
                <TableBody>
                  {InitialData?.slice(
                    Page * RowsPerPage,
                    Page * RowsPerPage + RowsPerPage
                  ).map((row, i) => (
                    <StyledTableRow key={i} sx={{backgroundColor:i % 2 !== 0 ? "#FFFFFF0F" : "#343435CC",}}>
                      <StyledTableCell className="text-center">
                        <p>{i + 1}</p>
                      </StyledTableCell>
                      <StyledTableCell>
                        <CustomTooltip title={row.transactionHash} placement="right">
                          {" "}
                          <a
                            href={
                              REACT_APP_TRANSACTION_HASHLINK+
                              row?.transactionHash
                            }
                            target="blank"
                            style={{ color: "#fff" }}
                          >
                            <p>
                              {row?.transactionHash?.slice(0, 8) +
                                "...." +
                                row?.transactionHash?.slice(-8)}
                            </p>
                          </a>
                        </CustomTooltip>
                      </StyledTableCell>
                      <StyledTableCell>
                        <Grid
                          display={"flex"}
                          flexDirection={"row"}
                          alignItems={"center"}
                        >
                          <img
                            src={EnshieldLogo}
                            alt="coin"
                            style={{ height: "25px", width: "25px" }}
                          />
                          <p className="mx-2">{row.amount}</p>
                        </Grid>
                      </StyledTableCell>
                      <StyledTableCell>
                        <p>{FormatDate(row?.date)}</p>{" "}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <StyledTableRow>
                    <StyledTableCell colSpan={7} align="center">
                      <p className="text-center text-light">
                        No Transaction History
                      </p>
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              )
            ) : (
              <TableBody>
                <StyledTableRow>
                  <StyledTableCell colSpan={7} align="center">
                    <span className="regular">
                      <CircularProgress style={{ color: "#FFFF" }} />
                    </span>
                  </StyledTableCell>
                </StyledTableRow>
              </TableBody>
            )}
          </Table>
        </TableContainer>
        {InitialData?.length > 10 ? (
          <Grid
            container
            lg={12}
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            justifyContent={"flex-start"}
          >
            <Grid
              item
              lg={6}
              xs={12}
              display={"flex"}
              justifyContent={"flex-start"}
              alignItems={"flex-start"}
            >
              <CustomTablePagination
                colSpan={8}
                rowsPerPageOptions={[10, 25, 50]}
                component="div"
                count={InitialData.length}
                rowsPerPage={RowsPerPage}
                page={Page}
                onPageChange={HandleChangePage}
                onRowsPerPageChange={HandleChangeRowsPerPage}
                labelRowsPerPage={null}
              />
            </Grid>
            <Grid
              item
              lg={6}
              xs={12}
              display={"flex"}
              justifyContent={"flex-end"}
              alignItems={"flex-end"}
            >
              <Pagination
                onPageChange={HandleChangePagePrev}
                onRowsPerPageChange={HandleChangeRowsPerPage}
                variant="outlined"
                shape="rounded"
                count={Math.ceil(InitialData.length / RowsPerPage)}
                page={Page1}
                onChange={HandleChangePagePrev}
              />
            </Grid>
          </Grid>
        ) : (
          ""
        )}
      </Grid>
    </Grid>
  );
};

export default WithDrawHistory;
